import styled from 'styled-components';

import InputStyles from 'admin-components/styles/input';

import Label from 'components/ui/Label';
import Select from 'components/ui/Select';
import { ActionButton } from 'components/ui/Button';

import { colours } from 'themes/default';

export const Text = styled.p`
  margin: 0 0 10px 0;
`;

export const FeeItemWrapper = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid ${colours.Greyscale.SilverGrey};

  &:last-child {
    border-bottom: none;
  }
`;

export const Container = styled.div`
  display: flex;

  > label {
    display: block;
    margin-right: 16px;
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;
`;

export const CheckboxWrapper = styled.div`
  display: block;
  margin-right: 16px;
`;

export const ReasonSection = styled.div`
  background-color: rgb(238, 242, 247);
  box-sizing: border-box;
  width: 100%;
  padding: 30px;
`;

export const ReasonLabel = styled(Label)`
  margin-right: 40px;
  text-transform: none;
`;

export const ReasonSelect = styled(Select)`
  width: 342px;
  margin-bottom: 12px;
`;

export const CalculateRefund = styled(ActionButton)`
  margin: 25px 0 10px 0;
  padding: 1.25em 2.5em;
`;

export const ExplanationLabel = styled(Label)`
  width: 100%;
  text-transform: none;
`;

export const ExplanationTextArea = styled.textarea`
  ${InputStyles}
  width: 100%;
  resize: vertical;
  padding: 0.6em 1.4em 0.5em 0.8em;
  border-color: ${colours.Greyscale.SilverGrey};
`;
